<template>
  <v-container>
    <conciliacao-toolbar style="position: sticky; top: 0" class="mb-4" />
    <conciliacao-resumo-guias class="mb-2" ref="conciliacaoResumoGuias" />
    <v-divider />
    <v-container class="mb-8" style="height: calc(100vh - 99px);">
      <div class="d-flex" style="height: inherit">
        <div class="flex-grow-1 pr-2" style="height: inherit; max-width: calc(50% - 0.5px)">
          <conciliacao-pagamento-itens-list />
        </div>

        <v-divider vertical />

        <div class="flex-grow-1 pl-2" style="height: inherit; max-width: calc(50% - 0.5px)">
          <template v-if="showFaturamentoItens">
            <conciliacao-faturamento-itens-list />
          </template>

          <template v-else>
            <conciliacao-faturamento-guias-list />
          </template>
        </div>
      </div>
    </v-container>
    <conciliacao-resumo-selecao v-if="showFaturamentoItens" :param="permiteSegundaConcRegular"/>

    <v-overlay :value="conciliandoGuiaAutomaticamente" opacity="0.8">
      <div class="d-flex flex-column align-center">
        <v-progress-circular class="mb-2" color="primary" indeterminate />
        <div>Conciliando guia...</div>
      </div>
    </v-overlay>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import ConciliacaoFaturamentoGuiasList from './conciliacao/ConciliacaoFaturamentoGuiasList.vue'
import ConciliacaoFaturamentoItensList from './conciliacao/ConciliacaoFaturamentoItensList.vue'
import ConciliacaoPagamentoItensList from './conciliacao/ConciliacaoPagamentoItensList.vue'
import ConciliacaoResumoGuias from './conciliacao/ConciliacaoResumoGuias.vue'
import ConciliacaoResumoSelecao from './conciliacao/ConciliacaoResumoSelecao.vue'
import ConciliacaoToolbar from './conciliacao/ConciliacaoToolbar.vue'

export default {
  components: {
    ConciliacaoFaturamentoGuiasList,
    ConciliacaoFaturamentoItensList,
    ConciliacaoPagamentoItensList,
    ConciliacaoResumoGuias,
    ConciliacaoResumoSelecao,
    ConciliacaoToolbar
  },
  props: {
    pagamentoId: { type: String, required: true },
    pagamentoLoteId: { type: String, required: true },
    pagamentoGuiaId: String,
    permiteSegundaConcRegular: Boolean
  },
  computed: {
    ...mapState('conciliacao', ['conciliandoGuiaAutomaticamente', 'showFaturamentoItens', 'permiteSegundaConcRegular'])
  },
  mounted () {
    const payload = {
      pagamentoId: this.pagamentoId,
      pagamentoLoteId: this.pagamentoLoteId,
      pagamentoGuiaId: this.pagamentoGuiaId,
      permiteSegundaConcRegular: this.permiteSegundaConcRegular      
    }
    //console.log("payload",payload) 

    this.$store.dispatch('conciliacao/pageInit', payload)
  }
}
</script>
